import React, { useEffect, useState } from 'react';
import './index.scss';
import { useTranslation } from '@/i18n/client';
import { Box, Tab, Tabs } from '@mui/material';

export default function CouponTitle(props: any) {
  const { t } = useTranslation();

  enum TabTypes {
    Available = 'available',
    NotAvailable = 'notavailable',
  }
  const tabList = [
    {
      label: t('coupon.available'),
      value: TabTypes.Available,
    },
    {
      label: t('coupon.couponHistory'),
      value: TabTypes.NotAvailable,
    },
  ];
  const [currentTab, setCurrentTab] = useState<TabTypes.Available | TabTypes.NotAvailable>(
    TabTypes.Available,
  );
  const handleTabChange = (tab: TabTypes.Available | TabTypes.NotAvailable) => {
    setCurrentTab(tab);
    props.refresh(tab);
  };

  useEffect(() => {}, []);

  return (
    <div className='applay-title'>
      <h1 className='applay-title-text'>{t('common.pageName.coupons')}</h1>
      <Box sx={{ position: 'relative' }}>
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '0.5px',
            backgroundColor: '#C2C4CC',
          }}
        />
        <Tabs
          value={currentTab}
          onChange={(e, tab) => handleTabChange(tab)}
          textColor='inherit'
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#000',
            },
          }}
        >
          {tabList.map((item: { label: string; value: string }, index: number) => {
            return (
              <Tab
                label={item.label}
                key={index}
                value={item.value}
                sx={{
                  fontSize: 16,
                  textTransform: 'none',
                  fontWeight: 700,
                  px: 0,
                  minWidth: 'auto',
                  mr: 4,
                  '&:last-child': {
                    mr: 0,
                  },
                }}
                disableRipple
              />
            );
          })}
        </Tabs>
      </Box>
    </div>
  );
}
